<template>
  <el-popover
    placement="left"
    trigger="click"
    popper-class="popover-box"
    :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: true }"
     :popper-append-to-body="false"
  >
    <div
      class="my-table-container"
      style="min-height: 180px; max-height:280px;width: 640px"
    >
      <el-table
        border
        class="examinationTable"
        :data="gridData"
        style="width: 100%;"
        :max-height="250"
      >
        <el-table-column
          min-width="15%"
          property="baseDataValue"
          align="center"
          label="结果值"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="15%"
          property="appId"
          align="center"
          label="AppID"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="15%"
          property="channelName"
          align="center"
          label="渠道名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="15%"
          property="sourcePort"
          align="center"
          label="来源端"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="15%"
          property="sourceEntrance"
          align="center"
          label="来源入口"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="15%"
          property="sourceCategory"
          align="center"
          label="来源类别"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="20%"
          property="recordDate"
          align="center"
          label="时间"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>

    <div class="block101 my-el-popover-pag">
      <el-pagination
        background
        :current-page="current"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :total="totalCount"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-count="3"
      ></el-pagination>
    </div>
    <span
      @click="clickValue(item)"
      class="itemValue"
      slot="reference"
      >{{ value }}</span
    >
  </el-popover>
</template>

<script>
import {
  getHPageItem,
  getUesrHistoryHealthDocRecordByPhoneNumber
} from "@/config/healthApi.js";

export default {
  name: "elPoperView",
  props: {
    item: {
      type: Object,
      default: {}
    },
    value: {
      type: String,
      default: ""
    },
    isBaseInfo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 当前结果条数
      totalCount: 0,
      // 当前激活页码
      current: 1,
      //可选的每页条数
      pageSizes: [10, 20, 30, 40],
      // 每页显示多少条
      pageSize: 10,
      dataItem: null,
      gridData: null
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getHPageItem(this.dataItem);
    },
    handleCurrentChange(index) {
      if (index == this.current) {
        return;
      } else {
        this.current = index;
      }
      this.getHPageItem(this.dataItem);
    },
    async getHPageItem(item) {
      let data = null;
      if (this.$store.state.healthDocUser.isChannelArchive) {
        let profileid = this.$store.state.healthDocUser.profileId;
        let appId = this.$store.state.healthDocUser.customerAppId;
        data = await getHPageItem({
          profileId: profileid,
          appId: appId,
          baseDataItem: this.isBaseInfo ? item.dataItem : item.baseDataItem,
          baseDataItemCode: this.isBaseInfo
            ? item.dataItemCode
            : item.baseDataItemCode,
          pageNum: this.current,
          pageSize: this.pageSize
        });
      } else {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getUesrHistoryHealthDocRecordByPhoneNumber({
          phoneNumber: phone,
          baseDataItemCode: this.isBaseInfo
            ? item.dataItemCode
            : item.baseDataItemCode,
          pageNum: this.current,
          pageSize: this.pageSize
        });
      }
      if (data.code == 200) {
        this.gridData = data.data.resultList;
        this.totalCount = data.data.dataTotal;
      }
    },
    clickValue(item) {
      if (this.dataItem == item) {
        return;
      }
      this.current = 1;
      this.getHPageItem(item);
      this.dataItem = item;
    }
  }
};
</script>

<style lang="scss">
.popover-box {
  width: 640px;
  
}
</style>

<style lang="scss" scoped>

.itemValue {
  width: max-content;
  /* display: flex; */
  font-size: 14px;
  text-align: left;
}

.block101 {
  text-align: center;
  margin-top: 23px;
}

.my-table-container {
  width: 700px;
  /* height: 530px; */
}

.examinationTable {
  width: 100%;
  height: 100%;
  /* height: 300px; */
}
</style>

<style>
.block101 .el-pager li:last-child {
  display: inline-block !important;
}

.block101 .el-pager li:first-child {
  display: inline-block !important;
}
</style>
